<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.action.title',2)}}</div>
    <alert-box v-model="alert.alerts" :type="alert.type"></alert-box>
    <btn-a rounded color="primary" @click="editItem" :access="$access.action.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :noAction="noAction"
      :multiple="multiple"
      :singleSelect="singleSelect"
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
      @input="pagination.page = $event"
      @click="clickTable($event)"
      @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.action.title',1)"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.validate())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.action.edit"
      :accessDelete="$access.action.delete"
      :alert="form.alert"
    >
      <actionForm v-if="itemSelected" ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import actionService from "@/services/actionService";
import actionForm from "../components/forms/actions/actionForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  mixins: [pageListMixing],
  components: { actionForm },

  data() {
    return {
      apiController: "action",
      entityService: actionService,
      searchFields: ["code", "description","entity","type"],
      headers: [
        {
          text: this.$t("entities.action.props.code"),
          align: "left",
          sortable: false,
          value: "code",
        },
        {
          text: this.$t("entities.action.props.description"),
          align: "left",
          sortable: false,
          value: "description",
        },
          {
          text: this.$t("entities.action.props.entity"),
          align: "left",
          sortable: false,
          value: "entity",
        },
           {
          text: this.$t("entities.action.props.type"),
          align: "left",
          sortable: false,
          value: "type",
        },

        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right",
        },
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.action.edit, this.$access.action.show],
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.action.delete,
        },
      ],
    };
  },
  methods: {
    async getModelDefault() {
      return {
        code: await this.getAutoInc(this.apiController),
        description: "",
        path:'',
        fields:[]
        
      };
    },
  },
  async mounted() {
    await this.getItems();
  },
};
</script>